import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./css/components.css";
import { isEditable } from "../utils/tramite";
import { useTramite } from "../context/Tramite";
import { isInvalid } from "../utils/forms";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import TextField from "./controls/TextField";
import QuestionField from "./controls/QuestionField";

export default function TransformadoresPCBForm({ ...props }) {
  const { tramite } = useTramite();
  const tramiteForm = useFormikContext();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const handleRegistroEquiposPCBChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleConCertificadoLibrePCBChange = (event) => {
    tramiteForm.handleChange(event);
  };
  useEffect(() => {
    setLoading(!tramite);
  }, [tramite]);
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={3}>
            <TextField
              id="registroEquiposPCB"
              name="registroEquiposPCB"
              label={t("tramite.registroEquiposPCB")}
              value={tramiteForm.values?.registroEquiposPCB}
              maxLength={20}
              onChange={handleRegistroEquiposPCBChange}
              labelStyle={{ whiteSpace: "nowrap" }}
              isInvalid={isInvalid("registroEquiposPCB", tramiteForm)}
              error={t(tramiteForm.errors.registroEquiposPCB)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="conCertificadoLibrePCB"
              name="conCertificadoLibrePCB"
              label={t("tramite.conCertificadoLibrePCB")}
              value={tramiteForm.values?.registroEquiposPCB}
              onChange={handleConCertificadoLibrePCBChange}
              isInvalid={isInvalid("conCertificadoLibrePCB", tramiteForm)}
              error={t(tramiteForm.errors.conCertificadoLibrePCB)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
